import Vimeo from '@u-wave/react-vimeo';
import Image from 'next/image';
import { FC, useRef, useState } from 'react';

import { useWindowSize } from '../../hook/useWindowSize';
import BusinessButton from '../business-button/business-button';
import { POSITION } from '../business-button/business-button.constants';
import styles from './business-hub-hero-home.module.scss';

export type HeroHomeProps = {
    video: string;
    imagePlaceholder?: string;
    imageMobile: string;
    title: string;
    description: string;
    ctaText?: string;
    borderRadiusBackground?: boolean;
    ctaLink?: string;
};

const BusinessHubHeroHome: FC<HeroHomeProps> = (props) => {
    const { video, imagePlaceholder, title, description, ctaText, ctaLink, borderRadiusBackground, imageMobile } = props;

    const { width = 0 } = useWindowSize();

    const [volume, setVolume] = useState(0);
    const videoContainerRef = useRef<HTMLDivElement>(null);

    if (!video || !title || !description) {
        return null;
    }

    return (
        <div
            className={styles.container}
            style={
                {
                    ['--borderRadius']: borderRadiusBackground ? '30px' : '0px',
                } as React.CSSProperties
            }
        >
            <div className={styles.imageHero}>
                <Image
                    src={(width > 992 ? imagePlaceholder : imageMobile) || ''}
                    alt=""
                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                    fill={true}
                    loading={'eager'}
                    loader={({ src, width, quality }) => {
                        return `${src}?width=${width}&quality=${quality ?? 75}`;
                    }}
                />
            </div>
            {width > 992 ? (
                <div ref={videoContainerRef} className={styles.videoHero}>
                    <Vimeo
                        onLoaded={() => {
                            videoContainerRef?.current?.classList.add(styles.loaded);
                        }}
                        video={video}
                        muted
                        volume={volume}
                        autoplay={true}
                        controls={false}
                        loop={true}
                        onVolumeChange={(e) => setVolume(e.volume)}
                    />
                </div>
            ) : null}

            <div className={styles.content}>
                <div className={styles.wrapperText}>
                    <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }}></div>
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }}></div>
                    <BusinessButton className={styles.btn} link={ctaLink} buttonText={ctaText} position={POSITION.LEFT} autoMargin={false} target="_blank" />
                </div>
            </div>
        </div>
    );
};

export default BusinessHubHeroHome;
